/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2021-12-31 11:05:42
 * @LastEditors: K
 * @LastEditTime: 2022-09-27 11:57:59
 */
import { Space, TableColumnType } from 'antd'
import React, { ReactElement } from 'react'
import { ThemeData } from '../../../theme/ThemeContext'

export const columns = (
  onClick: (type: 'setting' | 'relieve' | 'herbs' | 'againBind', tenant: any) => void,
  startIndex: number,
  theme: ThemeData
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '代煎供应商名称',
      key: 'name',
      align: 'center',
      dataIndex: 'name',
      width: '12rem',
    },
    {
      title: '代煎类别',
      key: 'decoctionType',
      align: 'center',
      dataIndex: 'decoctionType',
      width: '8rem',
    },
    {
      title: '加工方式',
      key: 'tenantCategory',
      align: 'center',
      dataIndex: 'machiningType',
      width: '8rem',
    },
    {
      title: '代煎绑定时间',
      key: 'updateTime',
      align: 'center',
      width: '12rem',
      dataIndex: 'updateTime',
    },
    {
      title: '签约状态',
      key: 'signedType',
      align: 'center',
      dataIndex: 'signedType',
      width: '8rem',
      render: (_, t) => (t.signedType === 1 ? '已签约' : '未签约'),
    },
    {
      title: '状态',
      key: 'status',
      align: 'center',
      width: '10rem',
      render: (_, t) => (t.bindingStatus === 1 ? '正常' : '已解绑'),
    },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      width: '16em',
      render: function ActionBar(_, t): ReactElement {
        return t.bindingStatus !== 1 ? (
          <a onClick={() => onClick('againBind', t)}>重新绑定</a>
        ) : (
            <Space>
            <a onClick={() => onClick('setting', t)}>代煎设置</a>
              <a onClick={() => onClick('herbs', t)}>商品目录 </a>
            <a
              onClick={() => onClick('relieve', t)}
              style={{ marginLeft: 15, color: 'red' }}
            >
              解除绑定
            </a>
            </Space>
        )
      },
    },
  ]
}
